import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import { getBlobImage, createImage, downloadImage } from '../../../helpers/canvasHelpers';
import { withoutFormat } from '../../../helpers/imageHelper';

const zip = new JSZip();
const img = zip.folder('images');

const getBlob = (image, previews, width, height, positions) => {


    return previews.map((preview, index) => {
        const position = positions.filter(position => position.index === preview.index);

        return getBlobImage(
            image,
            width,
            height,
            preview.width,
            preview.height,
            position && position.length ? position[0].left : 0,
            position && position.length ? position[0].top : 0
        );
    });
}

export const archiveDownload = (image, imageName, previews, width, height, positions, selected) => {
    const previewSelected = previews
    .map((previews, index) => { return { ...previews, index: index } })
    .filter((preview, indexPreview) => selected.includes(indexPreview));

    const previewPositionsSelected = positions
        .filter((position) => selected.includes(position.index))
        .sort((positionFirst, positionSecind) => positionFirst.index - positionSecind.index);

    const images = getBlob(image, previewSelected, width, height, previewPositionsSelected);

    Promise.all(images).then((image) => {
        image.map((base64Image, key) => {
            img.file(`${withoutFormat(imageName)}_${key}.jpg`, base64Image, { base64: true });
        });
    }).then(() => {
        zip.generateAsync({ type: 'blob' }).then(function (content) {
            saveAs(content, `${withoutFormat(imageName)}.zip`);
        });
    });
}


export const imageDownload = (
    imageName: string, imageSrc: string, imageWidth: number, imageHeight: number,
    canvasWidth, canvasHeight, positionX, positionY
) => {
    downloadImage(imageName, imageSrc, imageWidth, imageHeight, canvasWidth, canvasHeight, positionY, positionX);
}

export const imageResize = (widthImage, heightImage, widthCanvas, heightCanvas) => {
    const imageWidthProperties = widthImage / widthCanvas;
    const imageHeightProperties = heightImage / heightCanvas;

    const resizeProperties =
        imageWidthProperties < imageHeightProperties
            ? imageWidthProperties
            : imageHeightProperties;

    return {
        width: widthImage / resizeProperties,
        height: heightImage / resizeProperties,
    };
}